import React from 'react';

const SvgFeatureFireplace = props => (
	<svg viewBox="0 0 100 100" {...props}>
		<path
			fill="currentColor"
			d="M90.8 30.1H9.2c-1.6 0-2.9-1.3-2.9-2.9v-7.8c0-1.6 1.3-2.9 2.9-2.9h81.6c1.6 0 2.9 1.3 2.9 2.9v7.8c0 1.6-1.3 2.9-2.9 2.9zm-81.5-3h81.3v-7.5H9.3v7.5zm82 57.4H8.7c-1.3 0-2.4-1.1-2.4-2.4v-5c0-1.3 1.1-2.4 2.4-2.4h82.5c1.3 0 2.4 1.1 2.4 2.4v5c.1 1.3-1 2.4-2.3 2.4zm-82-3h81.3v-3.7H9.3v3.7z"
		/>
		<path
			fill="currentColor"
			d="M33 77.6H12.9c-.8 0-1.5-.7-1.5-1.5V28.6c0-.8.7-1.5 1.5-1.5H33c.8 0 1.5.7 1.5 1.5v47.6c0 .7-.7 1.4-1.5 1.4zm-18.6-3h17.1V30.1H14.4v44.5zm73.4 2.9H67.6c-.8 0-1.5-.7-1.5-1.5V28.6c0-.8.7-1.5 1.5-1.5h20.1c.8 0 1.5.7 1.5 1.5V76c.1.9-.6 1.5-1.4 1.5zm-18.7-3h17.1V30.1H69.1v44.4z"
		/>
		<path
			fill="currentColor"
			d="M33 39.6H12.9c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5H33c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5z"
		/>
		<path
			fill="currentColor"
			d="M19.3 39.6c-.8 0-1.5-.7-1.5-1.5v-9.6c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v9.6c0 .8-.7 1.5-1.5 1.5zM33 49.2H12.9c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5H33c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5z"
		/>
		<path
			fill="currentColor"
			d="M26.1 49.2c-.8 0-1.5-.7-1.5-1.5v-9.6c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v9.6c0 .8-.7 1.5-1.5 1.5zm6.9 9.5H12.9c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5H33c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5z"
		/>
		<path
			fill="currentColor"
			d="M19.3 58.7c-.8 0-1.5-.7-1.5-1.5v-9.6c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v9.6c0 .8-.7 1.5-1.5 1.5zM33 68.3H12.9c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5H33c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5z"
		/>
		<path
			fill="currentColor"
			d="M26.1 68.3c-.8 0-1.5-.7-1.5-1.5v-9.6c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v9.6c0 .8-.7 1.5-1.5 1.5zm-6.8 9.5c-.8 0-1.5-.7-1.5-1.5v-9.6c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v9.6c0 .8-.7 1.5-1.5 1.5z"
		/>
		<path
			fill="currentColor"
			d="M33 77.8H12.9c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5H33c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5zm54.8-38.2H67.6c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h20.1c.8 0 1.5.7 1.5 1.5s-.6 1.5-1.4 1.5z"
		/>
		<path
			fill="currentColor"
			d="M81.4 39.6c-.8 0-1.5-.7-1.5-1.5v-9.6c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v9.6c0 .8-.7 1.5-1.5 1.5zm6.4 9.6H67.6c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h20.1c.8 0 1.5.7 1.5 1.5s-.6 1.5-1.4 1.5z"
		/>
		<path
			fill="currentColor"
			d="M74.6 49.2c-.8 0-1.5-.7-1.5-1.5v-9.6c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v9.6c0 .8-.7 1.5-1.5 1.5zm13.2 9.5H67.6c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h20.1c.8 0 1.5.7 1.5 1.5s-.6 1.5-1.4 1.5z"
		/>
		<path
			fill="currentColor"
			d="M81.4 58.7c-.8 0-1.5-.7-1.5-1.5v-9.6c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v9.6c0 .8-.7 1.5-1.5 1.5zm6.4 9.6H67.6c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h20.1c.8 0 1.5.7 1.5 1.5s-.6 1.5-1.4 1.5z"
		/>
		<path
			fill="currentColor"
			d="M74.6 68.3c-.8 0-1.5-.7-1.5-1.5v-9.6c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v9.6c0 .8-.7 1.5-1.5 1.5zm6.8 8.6c-.8 0-1.5-.7-1.5-1.5v-8.6c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v8.6c0 .8-.7 1.5-1.5 1.5zm-37.3.6c-.2 0-.3 0-.5-.1-2.2-.7-6.1-3.3-5.8-8.3.3-5.2 5-9.6 5.2-9.8.4-.4 1.1-.5 1.6-.3.5.3.9.8.9 1.4-.1 1.7 0 3.4.1 4.7.5-1.2.9-2.9.8-4.8-.2-3.7-2.6-8.7-2.7-8.7-.3-.5-.2-1.1.2-1.6s1-.7 1.5-.5c.4.1 9.8 2.4 11.4 9 .2 1.1.2 2.1.1 2.9.4-.6.6-1.3.5-2-.1-.8.4-1.5 1.1-1.7.7-.2 1.5.2 1.8.9.3.7 2.5 6.9 2.1 10.6-.4 4-5.1 7.5-5.6 7.9-.7.5-1.6.3-2.1-.3-.5-.7-.3-1.6.3-2.1 1.1-.8 4.2-3.5 4.4-5.7.1-1.3-.2-3.2-.7-5-.6.7-1.3 1.3-2 1.7-1.7 1-2.7.7-3.3.3-1.3-1-.6-2.5-.2-3.2.4-.9 1-2 .6-3.6-.7-2.8-3.7-4.7-6.1-5.7.7 2 1.5 4.5 1.6 6.7.2 3.7-1.2 7.3-2.7 8.6-.8.7-1.5.8-1.9.8-.8-.1-2-.2-2.3-5.1-.9 1.3-1.7 3-1.8 4.7-.3 4 3.6 5.2 3.7 5.3.8.3 1.2 1.1 1 1.9 0 .7-.6 1.1-1.2 1.1z"
		/>
	</svg>
);

export default SvgFeatureFireplace;
